var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShown)?_c('div',{staticClass:"splash-screen"},[_c('p',[_vm._v(_vm._s(_vm.mode))]),_c('div',{staticClass:"splash-screen__loader"},[_c('Loader')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }